export const groupNotebookPages = (
    notebookPages = []
) => {
    return notebookPages.reduce(
        (groups, page) => {
            const chapterName =
                page.chapterTitle?.trim() ||
                "Unassigned";

            if (!groups[chapterName]) {
                groups[chapterName] = [];
            }

            groups[chapterName].push(
                page
            );

            return groups;
        },
        {}
    );
};

export const saveNotebookPages = (
    storageKey,
    pages,
    errorMessage =
        "Unable to save notebook pages:"
) => {
    try {
        localStorage.setItem(
            storageKey,
            JSON.stringify(pages)
        );

        return true;
    } catch (error) {
        console.error(
            errorMessage,
            error
        );

        return false;
    }
};

export const buildNotebookPage = ({
    notebookPages = [],
    pageType = "lesson",
}) => {
    const timestamp =
        new Date().toISOString();

    const nextNumber =
        notebookPages.length + 1;

    return {
        id: `note-page-${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 8)}`,

        pageType,

        title:
            pageType === "review"
                ? "Review"
                : pageType === "project"
                  ? "Project"
                  : pageType === "assessment"
                    ? "Quiz / Test Notes"
                    : `Lesson ${nextNumber}`,

        chapterTitle: "",
        unitTitle: "",
        sectionTitle: "",

        lessonNumber:
            nextNumber,

        content: "",

        createdAt: timestamp,
        updatedAt: timestamp,
    };
};

export const updateNotebookPage = ({
    notebookPages = [],
    pageId,
    title,
    chapterTitle,
    sectionTitle,
}) => {
    const timestamp =
        new Date().toISOString();

    return notebookPages.map((page) =>
        page.id === pageId
            ? {
                  ...page,
                  title:
                      title?.trim() ||
                      "Untitled Lesson",
                  chapterTitle:
                      chapterTitle?.trim() ||
                      "",
                  sectionTitle:
                      sectionTitle?.trim() ||
                      "",
                  updatedAt:
                      timestamp,
              }
            : page
    );
};

export const removeNotebookPage = ({
    notebookPages = [],
    pageId,
}) => {
    return notebookPages.filter(
        (page) =>
            page.id !== pageId
    );
};